"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Emitter = function () {
  function Emitter() {
    _classCallCheck(this, Emitter);
  }

  _createClass(Emitter, [{
    key: "on",
    value: function on(t, e) {
      this.onCount(t, null, e);
    }
  }, {
    key: "onCount",
    value: function onCount(t, e, l) {
      var n = this.eventStack;null == n && (this.eventStack = n = {}), null == n[t] && (n[t] = []), n[t].push({ count: e, callback: l });
    }
  }, {
    key: "one",
    value: function one(t, e) {
      this.onCount(t, 1, e);
    }
  }, {
    key: "emit",
    value: function emit(t) {
      var l = [];if (null != this.eventStack && this.eventStack[t]) {
        var n = this.eventStack[t];
        for (var _len = arguments.length, e = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          e[_key - 1] = arguments[_key];
        }

        for (var _t = 0; _t < n.length; _t++) {
          var c = n[_t],
              o = c.callback;null != c.count && (c.count--, c.count <= 0 && (n.splice(_t, 1), _t--));try {
            o.apply(this, e);
          } catch (t) {
            l.push(t);
          }
        }
      }if (l.length) throw l;
    }
  }]);

  return Emitter;
}();

module.exports = Emitter;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkVtaXR0ZXIuanMiXSwibmFtZXMiOlsiRW1pdHRlciIsIm5hbWUiLCJjYWxsYmFjayIsInRoaXMiLCJvbkNvdW50IiwiW29iamVjdCBPYmplY3RdIiwiY291bnQiLCJldmVudFN0YWNrIiwicHVzaCIsImFyZ3MiLCJlcnJvcnMiLCJjYWxsYmFja3MiLCJpIiwibGVuZ3RoIiwiZW50cnkiLCJzcGxpY2UiLCJhcHBseSIsImV4IiwibW9kdWxlIiwiZXhwb3J0cyJdLCJtYXBwaW5ncyI6Ijs7Ozs7O0lBRU1BLE87Ozs7Ozs7dUJBQ0NDLEMsRUFBTUMsQyxFQUFBQTtBQUNMQyxXQUFLQyxPQUFMRCxDQUFhRixDQUFiRSxFQUFtQixJQUFuQkEsRUFBeUJELENBQXpCQztBQUdKRTs7OzRCQUFRSixDLEVBQU1LLEMsRUFBT0osQyxFQUFBQTtBQUNqQixVQUFJSyxJQUFhSixLQUFLSSxVQUF0QixDQUVpQixRQUFkQSxDQUFjLEtBQ2JKLEtBQUtJLFVBQUxKLEdBQWtCSSxJQUFBQSxFQURMLEdBSU0sUUFBcEJBLEVBQVdOLENBQVhNLENBQW9CLEtBQ25CQSxFQUFXTixDQUFYTSxJQUFXTixFQURRLENBSk4sRUFRakJNLEVBQVdOLENBQVhNLEVBQWlCQyxJQUFqQkQsQ0FBaUJDLEVBQ2JGLE9BQU9BLENBRE1FLEVBRWJOLFVBQVVBLENBRkdNLEVBQWpCRCxDQVJpQjtBQWNyQkY7Ozt3QkFBSUosQyxFQUFNQyxDLEVBQUFBO0FBQ05DLFdBQUtDLE9BQUxELENBQWFGLENBQWJFLEVBQW1CLENBQW5CQSxFQUFzQkQsQ0FBdEJDO0FBR0pFOzs7eUJBQUtKLEMsRUFBU1E7QUFDVixVQUFJQyxJQUFBQSxFQUFKLENBRUEsSUFBc0IsUUFBbkJQLEtBQUtJLFVBQWMsSUFBUUosS0FBS0ksVUFBTEosQ0FBZ0JGLENBQWhCRSxDQUE5QixFQUFxRDtBQUNqRCxZQUFJUSxJQUFZUixLQUFLSSxVQUFMSixDQUFnQkYsQ0FBaEJFLENBQWhCO0FBRGlELDBDQUgzQ00sQ0FHMkM7QUFIM0NBLFdBRzJDO0FBQUE7O0FBR2pELGFBQUksSUFBSUcsS0FBSSxDQUFaLEVBQWVBLEtBQUlELEVBQVVFLE1BQTdCLEVBQXFDRCxJQUFyQyxFQUEwQztBQUN0QyxjQUFJRSxJQUFRSCxFQUFVQyxFQUFWRCxDQUFaO0FBQUEsY0FDSVQsSUFBV1ksRUFBTVosUUFEckIsQ0FFa0IsUUFBZlksRUFBTVIsS0FBUyxLQUNkUSxFQUFNUixLQUFOUSxJQUVHQSxFQUFNUixLQUFOUSxJQUFlLENBQWZBLEtBQ0NILEVBQVVJLE1BQVZKLENBQWlCQyxFQUFqQkQsRUFBb0IsQ0FBcEJBLEdBQ0FDLElBRkRFLENBSFcsRUFTbEIsSUFBQTtBQUNJWixjQUFTYyxLQUFUZCxDQUFlQyxJQUFmRCxFQUFxQk8sQ0FBckJQO0FBRUosV0FIQSxDQUdBLE9BQU1lLENBQU4sRUFBTUE7QUFDRlAsY0FBT0YsSUFBUEUsQ0FBWU8sQ0FBWlA7QUFBWU87QUFBQUE7QUFLeEIsV0FBR1AsRUFBT0csTUFBVixFQUNJLE1BQU1ILENBQU47QUFBTUE7Ozs7OztBQUtsQlEsT0FBT0MsT0FBUEQsR0FBaUJsQixPQUFqQmtCIn0=